module.exports = __webpack_public_path__ + "img/62.2dc9b97a.png";